import script from "./RoomClosedTip.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomClosedTip.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__